import { createContext } from 'react';
export const PortableTextContext = createContext(undefined);
